import { useEffect, useState } from "react";

/*
 Hook to asynchronously observe if a target element intersects with an ancestor element or the window viewport
 https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 */

interface Props {
  onChange?: (isIntersecting: boolean, observer: IntersectionObserver) => void;
  options: IntersectionObserverInit;
  target: Element | null;
}

export function useElementOnScreen({
  options,
  target,
  onChange
}: Props): { isVisible: boolean } {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
      if (onChange) {
        onChange(entry.isIntersecting, observer);
      }
    }, options);

    if (target) {
      observer.observe(target);
    }

    return (): void => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [target, options, onChange]);

  return {
    isVisible
  };
}
